jQuery_T4NT(document).ready(function($) {

     /**
     *  Variant selection changed
     *  data-variant-toggle="{{ variant.id }}"
     */
	   $( document ).on( "variant:changed", function( evt ) {
	     // console.log( evt.currentVariant );
	     // $('[data-variant-toggle]').hide(0);
	     // $('[data-variant-toggle="'+evt.currentVariant.id+'"]').show(0);
	   });

// Función para verificar y agregar parámetros a la URL
function checkAndAddParams() {
    // Obtener la URL actual
    let currentUrl = new URL(window.location.href);

    // Verificar si la URL contiene "/collections"
    if (currentUrl.pathname.includes("/collections")) {
        // Verificar si los parámetros de disponibilidad y talla ya están presentes
        let hasAvailabilityParam = currentUrl.searchParams.has("filter.v.availability");
        let hasSizeParam = Array.from(currentUrl.searchParams.keys()).some(param => param.startsWith("filter.v.option.talla"));

        // Si falta alguno de los parámetros, agregar el parámetro de disponibilidad
        if (!hasAvailabilityParam && hasSizeParam) {
            currentUrl.searchParams.append("filter.v.availability", "1");
            // Redirigir a la nueva URL
            window.history.replaceState({}, '', currentUrl.toString());
            location.reload();
        }
    }
}


  
// Ejecutar la función al cargar la página
checkAndAddParams();

// Sobrescribir los métodos pushState y replaceState para detectar cambios en la URL
(function(history) {
    let pushState = history.pushState;
    let replaceState = history.replaceState;

    history.pushState = function(state) {
        let result = pushState.apply(history, arguments);
        // Ejecutar la función para verificar y agregar parámetros
        checkAndAddParams();
        return result;
    };

    history.replaceState = function(state) {
        let result = replaceState.apply(history, arguments);
        // Ejecutar la función para verificar y agregar parámetros
        checkAndAddParams();
        return result;
    };
})(window.history);

// Escuchar cambios en el historial (cambios en la URL)
window.addEventListener('popstate', checkAndAddParams);

  
});

function clickFloatingButton() {
    const button = document.querySelector('.floating-button.circle.bottom.left');
    if (button) {
        button.click();
    } else {
        console.warn('El botón no fue encontrado.');
    }
}


    var tabImages = document.getElementsByClassName("tabimage");
  

  
    // Función para mostrar la imagen correspondiente al tab seleccionado
    function showImage(tabName) {
      for (var i = 0; i < tabImages.length; i++) {
        tabImages[i].style.display = "none"; // Ocultar todas las imágenes
      }
      document.getElementById(tabName).style.display = "block"; // Mostrar la imagen seleccionada
    }




